module.exports = __webpack_public_path__ + "f108e113b1427510f2025826db1f83ca.svg";